<template>
    <b-container fluid class="py-3 flex-grow-1 d-flex flex-column">
        <b-row class="flex-grow-1">
            <b-col class="flex-grow-1 d-flex flex-column">
                <div class="d-flex justify-content-between mb-3">
                    <b-button
                        :to="{name: 'usersAdd'}"
                        class="btn-arrow ml-auto"
                        variant="primary"
                    >
                        <span class="d-inline d-lg-none">Add</span>
                        <span
                            class="d-none d-lg-inline">Add new user</span>
                        <font-awesome-icon
                            :icon="['far', 'arrow-right']"
                        ></font-awesome-icon>
                    </b-button>
                </div>
                <div class="grid-wrapper flex-grow-1 d-flex">
                    <ag-grid-vue
                        :style="'width: ' + gridWidth +'%;'"
                        class="ag-theme-balham"

                        :cacheQuickFilter="true"
                        @cellClicked="selectUser"

                        :columnDefs="columnDefs"
                        :defaultColDef="defaultColDef"
                        :floatingFilter="false"

                        :gridOptions="gridOptions"

                        @gridReady="onGridReady"
                        :headerHeight="rowHeight"
                        :rowData="rowData"
                        :rowHeight="rowHeight"

                        :suppressContextMenu="true"
                        :suppressExcelExport="true"

                        rowSelection="single"
                    ></ag-grid-vue>
                </div>
            </b-col>
        </b-row>
        <user-item
            :user-id="selected.userId"
            @save="refresh"
            :show.sync="showUserModal"
        ></user-item>
    </b-container>
</template>

<script>
import { gridColumns, gridDefaultColDef } from '@/services/User/UserGrid';
import GridMixin from '@/components/Grid/GridMixin';
import User from '@/services/User/User';
import UserItem from '@/components/User/UserItem';

export default {
  name: 'Users',
  components: {
    UserItem,
  },
  mixins: [GridMixin],
  data() {
    return {
      rowData: [],
      defaultColDef: gridDefaultColDef,
      columnDefs: gridColumns,
      showUserModal: false,
      selected: {
        userId: null,
      },
    };
  },
  watch: {
    showUserModal(newValue) {
      if (!newValue) {
        this.selected.userId = null;
      }
    }
  },
  methods: {
    postGridReady() {
      this.refresh();
      this.handleResize();
    },
    async refresh() {
      this.gridApi.showLoadingOverlay();
      const { data } = await User.list();
      this.rowData = data.data;
      this.gridApi.hideOverlay();
    },
    selectUser(node) {
      this.selected.userId = node.data.userId;
      this.showUserModal = true;
    },
    handleResize() {
      this.gridApi.sizeColumnsToFit();
    },
  },
};
</script>
